// src/components/dashboard/widgets/snapshot-panel.tsx
import { ChevronRight, ExternalLink } from 'lucide-react';

interface SnapshotItem {
  label: string;
  value: string | number;
  Icon: React.ComponentType<{ size?: number; className?: string }>;
}

interface SnapshotPanelProps {
  items: SnapshotItem[];
  onSelectSuggestion: (prompt: string) => void;
}

export default function SnapshotPanel({ items, onSelectSuggestion }: SnapshotPanelProps) {
  return (
    <div className="rounded-2xl border border-cream-line bg-warm-gray p-5 h-full">
      <div className="flex items-center gap-2 mb-4 text-sm font-semibold text-cream">
        <span>✦</span> Your snapshot
      </div>
      <div className="space-y-3">
        {items.map((item) => (
          <div key={item.label} className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-7 h-7 rounded-lg bg-leaf-500/8 flex items-center justify-center">
                <item.Icon size={13} className="text-leaf-400" />
              </div>
              <span className="text-sm text-cream-muted">{item.label}</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-sm font-medium text-cream">{item.value}</span>
              <ChevronRight size={13} className="text-cream-muted/40" />
            </div>
          </div>
        ))}
      </div>
      <button
        onClick={() => onSelectSuggestion("Generate today's daily report")}
        className="mt-5 w-full flex items-center justify-center gap-2 text-xs text-cream-muted hover:text-cream border border-cream-line rounded-xl py-2.5 transition-colors hover:bg-leaf-500/5"
      >
        <ExternalLink size={12} /> View full report
      </button>
    </div>
  );
}